import TumengSvgIcon from './src/index.vue'

TumengSvgIcon.install = function(Vue) {
  Vue.component(TumengSvgIcon.name, TumengSvgIcon)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengSvgIcon)
}

export default TumengSvgIcon
